import type { AssetKey } from '@/assets/manifest';
import { ResponsiveImage } from '@/components/media';
import { OrnamentIcon, type OrnamentIconName } from '@/components/ornaments';
import { cx } from '@/lib/cx';
import styles from './ProgramThumb.module.css';

/** Diámetro real del medallón en cada anchura, medido en el mockup (§S2). */
const THUMB_SIZES = '(min-width: 64rem) 106px, (min-width: 48rem) 86px, (min-width: 24.5rem) 72px, 64px';

export interface ProgramThumbProps {
  /** Miniatura CUADRADA del manifiesto de FORGE-BRAVO. */
  image?: AssetKey;
  /** Ornamento de reserva: sólo si el hito no tuviera fotografía. */
  icon: OrnamentIconName;
  className?: string;
}

/**
 * Miniatura circular del rail del programa — el rasgo premium de esta página.
 *
 * La foto va a sangre dentro del círculo. Es DECORATIVA a propósito: el título
 * del hito va justo al lado en texto real, así que describir además la
 * fotografía sólo añade ruido a un lector de pantalla (WCAG 1.1.1, imagen
 * junto a su texto equivalente).
 *
 * Si algún hito se quedara sin foto, el medallón cae a un ornamento dorado
 * sobre lavado aqua: se lee como una decisión, no como una imagen rota.
 */
export function ProgramThumb({ image, icon, className }: ProgramThumbProps) {
  return (
    <span className={cx(styles.thumb, className)}>
      {image ? (
        <ResponsiveImage asset={image} sizes={THUMB_SIZES} className={styles.photo} decorative />
      ) : (
        <span className={styles.fallback} aria-hidden="true">
          <OrnamentIcon name={icon} size={34} />
        </span>
      )}
    </span>
  );
}
